import React from 'react';
import s from './s.module.less';
import { TPrescriptionListItem } from 'types/textVisit';
import dayjs from 'utils/dayjs';

type Props = {
    prescription: TPrescriptionListItem;
    isForPrint?: boolean;
}

const PrescriptionCard = ({ prescription, isForPrint }: Props) => {
    const dayLeft = dayjs.utc(prescription.expires).diff(dayjs(), 'day');
    let expiredLabel = 'Expired';
    if (dayLeft > 0) {
        expiredLabel = `${dayLeft} days left`;
    }
    return (
        <div className={`${s.prescriptionCard} ${isForPrint ? s.print : ''}`}>
            <div className={s.detailItem}>
                <div className={s.medicationName}>{prescription.drugName}</div>
                <div className={s.detailValue}>{prescription.drugLine1}</div>
            </div>

            <div className={s.prescriptionDetails}>
                <div className={s.detailItem}>
                    <span className={s.detailLabel}>Quantity</span>
                    <span className={s.detailValue}>{prescription.quantity}</span>
                </div>
                <div className={s.detailItem}>
                    <span className={s.detailLabel}>Expires</span>
                    <span className={s.detailValue}>{dayjs.utc(prescription.expires).local().format('MM/DD/YYYY')} {expiredLabel}</span>
                </div>
            </div>

            <div className={s.detailItem}>
                <div className={s.detailLabel}>Directions</div>
                <div className={s.detailValue}>
                    {prescription.drugFormat}
                </div>
            </div>

            <div className={s.detailItem}>
                <div className={s.detailLabel}>Destination</div>
                <div className={s.detailValue}>
                    <div>{prescription.pharmacyBusinessName}-{prescription.pharmacyCity}, {prescription.pharmacyState}</div>
                    <div>{prescription.pharmacyAddressLine1} {prescription.pharmacyAddressLine2 ? `, ${prescription.pharmacyAddressLine2}` : ''} {prescription.pharmacyCity}, {prescription.pharmacyState}, {prescription.pharmacyPostalCode}</div>
                    <div>Phone: {prescription.pharmacyPhone}</div>
                </div>
            </div>
        </div>
    );
};

export default PrescriptionCard;